module.exports = __webpack_public_path__ + "img/banner.3349e8fd.png";